<template>
  <div v-bind="$attrs" data-dusk="tab-content-wrapper" class="tab-content-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabContentWrapper.vue",
  emits: ['input'],
  props: {
    value: {

      type: [String, Number],
      required: false,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
